import {Button} from "react-bootstrap";
import React, {useState} from "react";
import DatePicker, {registerLocale} from 'react-datepicker';
import PropertyTitle from "./PropertyTitle";

import "react-datepicker/src/stylesheets/datepicker.scss";
import nl from "date-fns/locale/nl";
import {exportGroupVisits} from "../services/Export";
import moment from "moment";

registerLocale("nl", nl);

const ExportVisitCountInput = ({group}) => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    return (
        <>
            <PropertyTitle small icon="bar-chart" text="Sessietellingen"/>
            <div style={{marginBottom: "2vh"}}>
                <b>Selecteer datumbereik</b>
                <br/>
                <DatePicker
                    locale="nl"
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    isClearable={true}
                />
            </div>
            <Button onClick={() => exportGroupVisits(
                group.id,
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD')
            )}
                    disabled={startDate == null || endDate == null}
                    className={"btn-primary"} variant="primary">
                Exporteer gegevens
            </Button>
        </>
    );
}
export default ExportVisitCountInput;
